export const getBudgetStepStyles = (_, { palette = {} }) => ({
  container: {
    '& .collapse-container': {
      gap: '16px',
    },
    '& .collapse-panel': {
      padding: '0 !important',
      borderRadius: '4px !important',
      marginBottom: '0px !important',

      '& .helpbutton': {
        '&::before': {
          verticalAlign: 'initial',
        },
      },

      '& .collapse-title-bar': {
        flexFlow: 'row wrap !important',
        padding: '16px 24px',
        minHeight: 'unset !important',
      },

      '&.collapse-fixed-panel': {
        '& .collapse-title-bar': {
          paddingBottom: '0',
        },
        '& .title-item': {
          width: 'auto',
          maxWidth: '100%',
        },
      },

      '&:not(.collapse-fixed-panel)': {
        '& .collapse-title-bar': {
          borderBottom: `1px solid ${palette.neutralLight}`,

          '& .title-item': {
            width: 'calc(100% - 18px)',
          },

          '& .error-string-wrapper': {
            position: 'unset',
            marginTop: '8px',
            width: '100%',
          },

          '& .toggle-icon': {
            fontSize: '18px',
          },
        },
      },

      '& .collapse-content': {
        padding: '12px 24px',
        marginBottom: '0 !important',

        '&.content-hide': {
          padding: '0',
        },
      },

      '& .collapse-content-details': {
        padding: '12px 24px',
      },
    },
  },

  title: {
    marginTop: '0',
    marginBottom: '16px',
    fontSize: '26px',
  },
  description: {
    marginBottom: '32px',
  },
  budgetHeader: {
  },
  budgetContent: {
    flexDirection: 'row',
    display: 'flex',
    columnGap: '32px',
  },
  'budgetContent-l': {
    flexDirection: 'column',
    rowGap: '16px',
  },

  'budgetContent-m': {
    flexDirection: 'column',
    rowGap: '16px',
  },
  'budgetContent-s': {
    flexDirection: 'column',
    rowGap: '16px',
    width: '100%',
  },
});
